import React from 'react';
import { Form, InputNumber, Row, Col, Divider } from 'antd';

export const TimersSettings: React.FC = () => {
  return (
    <>
      <Divider orientation="left">Корзина</Divider>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Таймер корзины (минуты)"
            name="cart_timer_minutes"
            rules={[
              { required: true, message: 'Укажите время' },
              { type: 'number', min: 1, max: 120, message: 'От 1 до 120 минут' }
            ]}
            help="Время жизни корзины с товарами"
          >
            <InputNumber 
              min={1} 
              max={120} 
              style={{ width: '100%' }}
              addonAfter="мин"
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Заказ</Divider>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Таймер оформления заказа (минуты)"
            name="order_timer_minutes"
            rules={[
              { required: true, message: 'Укажите время' },
              { type: 'number', min: 1, max: 30, message: 'От 1 до 30 минут' }
            ]}
            help="Время на оформление заказа после создания"
          >
            <InputNumber 
              min={1} 
              max={30} 
              style={{ width: '100%' }}
              addonAfter="мин"
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Оплата</Divider>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label="Таймер оплаты Halyk (минуты)"
            name="payment_halyk_timer_minutes"
            rules={[
              { required: true, message: 'Укажите время' },
              { type: 'number', min: 5, max: 60, message: 'От 5 до 60 минут' }
            ]}
            help="Время на оплату через Halyk Bank"
          >
            <InputNumber 
              min={5} 
              max={60} 
              style={{ width: '100%' }}
              addonAfter="мин"
            />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={12}>
          <Form.Item
            label="Таймер ручной оплаты (часы)"
            name="payment_manual_timer_hours"
            rules={[
              { required: true, message: 'Укажите время' },
              { type: 'number', min: 1, max: 24, message: 'От 1 до 24 часов' }
            ]}
            help="Время на ручную оплату"
          >
            <InputNumber 
              min={1} 
              max={24} 
              style={{ width: '100%' }}
              addonAfter="ч"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};